// extracted by mini-css-extract-plugin
module.exports = {"container":"WhiteCard_container__2So5v"};